import { pushButtonClick } from '@emico-utils/datalayer'
import type { PressEvent } from '@react-types/shared'
import { useCallback } from 'react'

const useButtonClick = (
  analyticsName?: string,
  analyticsContext?: string,
  onClick?: (e: PressEvent) => void,
) =>
  useCallback(
    (e: PressEvent) => {
      // Allow for tracking to be disabled explicitly
      // Users should be allowed to pass only analytics name or context
      if (analyticsName || analyticsContext) {
        pushButtonClick(analyticsName, analyticsContext)
      }

      if (onClick) {
        onClick(e)
      }
    },
    [analyticsContext, analyticsName, onClick],
  )

export default useButtonClick
